import React from 'react';

function CustomerName({
                        sendData, setSendData, initialData, componentData, setComponentData,
                      }) {

  return (<div className={"solid-dyna-input"}>
    <label htmlFor="">
      نام مشتری
    </label>
    <input
      placeholder={"نام مشتری"}
      value={sendData?.customerName ? sendData?.customerName : ""}
      onChange={e=> setSendData({customerName:e.target.value})}
    />
  </div>);
}

export default CustomerName;